/**
 * Voice notes HTTP API — direct browser calls to the Cloudflare Worker.
 * Used for audio streaming (which needs browser Audio API) and uploads.
 */
import { VOICE_NOTES_WORKER_URL, UPLOAD_SECRET } from "../config/constants";

export function getAudioStreamUrl(noteId: string): string {
  return `${VOICE_NOTES_WORKER_URL}/notes/${noteId}/stream`;
}

export async function uploadReply(
  audioBlob: Blob,
  recipientName: string
): Promise<boolean> {
  const form = new FormData();
  form.append("audio", audioBlob, "reply.webm");
  form.append("sender", "Мина (бабуш��а)");
  form.append("secret", UPLOAD_SECRET);
  if (recipientName) {
    form.append("recipient", recipientName);
  }

  try {
    const resp = await fetch(`${VOICE_NOTES_WORKER_URL}/upload`, {
      method: "POST",
      body: form,
    });
    return resp.ok;
  } catch {
    return false;
  }
}
